<template>
  <NuxtLayout name="loyalty">
    <div class="container--Medium defaultSectionMargins">
      <h1 v-text="page.title" />

      <div class="faq__List">
        <FaqItem v-for="item in page.faqs" :item="item" />
      </div>
    </div> 
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess',     
  })
  
  defineProps({
    page: {}
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_loyaltyFaq.scss');
</style>